import type {
  MapConfig,
  VectorSourceConfigFormat,
  VectorSourceConfig,
} from '@tmapy/beetlejuice-utils';

import { LAYER_TYPE } from '@tmapy/beetlejuice-utils';

export const mapConfig: () => MapConfig = () => ({
  resolutions: {
    '2048.256/2^14': [
      2048.256, 1024.128, 512.064, 256.032, 128.016, 64.008, 32.004, 16.002, 8.001, 4.0005, 2.00025,
      1.000125, 0.5000625, 0.25003125, 0.125015625,
    ],
  },

  layers: [
    ...(globalThis.DMX_CONFIG?.manager?.map?.svu?.layers ?? []),
    {
      id: 'predefined-areas',
      type: LAYER_TYPE.VECTOR,
      sourceOptions: {
        format: 'empty' as VectorSourceConfigFormat,
      } as VectorSourceConfig,
      style: 'HIGHLIGHT',
      layerOptions: { visible: true },
      features: [],
    },
  ],
  view: {
    projection: 'EPSG:5514', // 4326, 5514, 3857
    maxZoom: 20,
    minZoom: 7,
    zoom: globalThis.DMX_CONFIG?.manager?.map?.svu?.zoom ?? 10,
    center: globalThis.DMX_CONFIG?.manager?.map?.svu?.center ?? [-670000, -1130000],
    enableRotation: false,
  },
});
